<template>
  <div class="kontakt-informationen">
    <div class="container col12">
      <div :class="{'rw-tabs': !loading, vertical: true}">
        <div class="tabset">
          <div class="tab active">
            Anfrage
          </div>
        </div>
        <div class="tabs-container">
          <div class="tab-content">
            <p>Gerne senden wir Ihnen ein Angebot zu, geben Sie und dazu bitte Ihre Kontaktinformationen.</p>
            <div class="col-container">
              <div class="col">
                <div class="row name">
                  <select v-model="kontakt.anrede" v-validate.required>
                    <option disabled value="" v-validate.required>Anrede *</option>
                    <option value="Herr">Herr</option>
                    <option value="Frau">Frau</option>
                  </select>
                  <input type="text" v-model="kontakt.vorname" v-validate.required placeholder="Vorname *" />
                  <input type="text" v-model="kontakt.nachname" v-validate.required placeholder="Nachname *" />
                </div>
                <div class="row">
                  <input type="text" v-model="kontakt.firma" v-validate.required placeholder="Firma *" />
                </div>
                <div class="row">
                  <input type="text" v-model="kontakt.strasse" placeholder="Straße & Hausnummer" />
                </div>
                <div class="row ort">
                  <input type="text" v-model="kontakt.plz" placeholder="PLZ" />
                  <input type="text" v-model="kontakt.ort" placeholder="Ort" />
                </div>
                <div class="row">
                  <select v-model="kontakt.land" v-validate.required>
                    <option v-for="(land, key) in laender" :key="key" :value="key">{{land}}</option>
                  </select>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <input type="text" v-model="kontakt.telefon" placeholder="Telefon" />
                </div>
                <div class="row">
                  <input type="text" v-model="kontakt.email" v-validate.email placeholder="E-Mail *" />
                </div>
                <div class="row high">
                  <textarea placeholder="Ihre Nachricht" v-model="kontakt.nachricht"></textarea>
                </div>
              </div>
            </div>
            <p>
              <label>
                <input type="checkbox" class="konfig-checkbox" v-model="dsb" v-validate.checked /><span :class="{checked: dsb}"></span>
                Ich stimme den <a href="/impressum-datenschutz">Datenschutzbestimmungen</a> zu.
              </label>
            </p>
            <p>
              <label>
                <input type="checkbox" class="konfig-checkbox" v-model="kontakt.newsletter" /><span :class="{checked: kontakt.newsletter}"></span>
                Bitte senden Sie mir Informationen zu  Innovationen und Neuigkeiten zu.
              </label>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Options from '@/Options'

export default {
  name: 'KontaktInformationen',
  components: {
  },
  props: ['data'],
  data () {
    return {
      dsb: false,
      kontakt: Object.assign({
        firma: '',
        anrede: '',
        vorname: '',
        nachname: '',
        telefon: '',
        email: '',
        strasse: '',
        plz: '',
        ort: '',
        nachricht: '',
        land: 'DE',
        newsletter: false
      }, this.data),
      loading: true,
      laender: {'DE': 'Deutschland', 'XX': 'Sonstige'}
    }
  },
  methods: {
    getKontakt () {
      return this.kontakt
    },
    validate () {
      let valid = true
      for (let el of this.$el.querySelectorAll('input,select,textarea')) {
        if (el.validate) {
          if (el.validate() === false) {
            valid = false
          }
        }
      }
      return valid
    }
  },
  created () {
    Options.getOptions().then(options => {
      this.loading = false
      this.laender = options.laender
    })
  },
  watch: {
    data (val) {
      this.kontakt = Object.assign(this.kontakt, val)
    }
  }
}
</script>

<style scoped>
.tab-content {
  padding-bottom: 36px;
  padding-top: 12px !important;
  padding-left: 0 !important;
}

.tab-content > p {
  padding-left: 24px;
  padding-right: 24px;
}

.col-container {
  padding-left: 24px;
  padding-right: 18px;
}

.col-container::after {
  content: '';
  display: table;
  clear: both;
}

@media screen and (min-width: 480px) {
  .col {
    float: left;
    width: calc((100% - 18px) / 2);
  }

  .col:not(:last-child) {
    margin-right: 18px;
  }
}

.row {
  height: 48px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.row.high {
  height: auto;
}

.row > * {
  margin-right: 6px;
  width: calc(100% - 6px);
}

.row::after {
  content: '';
  display: table;
  clear: both;
}

.row.name > select {
  width: calc((100% - 18px) * 0.3);
  float: left;
  margin-right: 6px;
}

.row.name > input {
  width: calc((100% - 20px) * 0.35);
  float: left;
  margin-right: 6px;
}

.row.ort > input {
  width: calc((100% - 14px) * 0.3);
  float: left;
  margin-right: 6px;
}

.row.ort > input:last-child {
  width: calc((100% - 12px) * 0.7);
}

textarea {
  height: 132px;
  resize: none;
  overflow: auto;
}

input.invalid, select.invalid {
  border-bottom: 2px solid #d85200 !important;
}

@media screen and (max-width: 480px) {
  input, select {
    padding: 0 12px !important;
  }
}
.konfig-checkbox {
  display: none;
}
.konfig-checkbox + span{
  border: 2px solid #b8b8b8;
  position: relative;
  width: 18px;
  height: 18px;
  display: inline-block;
  top: 3px;
  margin-right: 6px;
}

.konfig-checkbox + span:hover {
  border-color: #54565A;
}

.konfig-checkbox + span.checked{
}

.konfig-checkbox.invalid + span {
  border-color: #d85200;
}
.konfig-checkbox + span.checked::after {
  content: "\e6fe";
  font-family: icomoon;
  color: #ec6608;
  position: absolute;
  left: -1px;
  top: -8px;
  font-size: 22px;
}

</style>



// WEBPACK FOOTER //
// src/components/KontaktInformationen.vue